export default __webpack_public_path__ + "static/media/QA_Training_Video.0eab7335.mp4";